<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      :disabled="sas.ventesPharmacie.length === 0"
      code="vente_ouinon"
      :live="liveSasSociete(25933)"
      v-model="sasSociete.declarerVentePharmacie"
    />
    <div v-show="conditionVente">
      <data-iterator
        :list="getListVente"
        add-new-text="Vendre une pharmacie"
        :live="{ endpoint: 'sas-vente-pharmacie', sasId: sas.id }"
        :icon="$getIcon('job')"
        :valids="valids"
        ref="dataIterator"
        hidePoints
        hideAddButton
        optional
      >
        <template v-slot:show-mode="{ item }">
          <OrganisationCardContent v-if="item.ventePharmacie" :organisation="item.ventePharmacie" />
          <CaseACocherLive
            :opqIf="conditionVente"
            @eudo-updated="cocherVendue(item)"
            code="pharmacie_vendue"
            v-model="item.jeSouhaiteVendreCettePharmacie"
            :live="liveSasVente(26605, item)"
          />
        </template>
        <template v-slot:edit-mode="{ item }">
          <OrganisationCardContent v-if="item.ventePharmacie" :organisation="item.ventePharmacie" />
          <DatePickerLive
            :opqIf="item.jeSouhaiteVendreCettePharmacie"
            code="vente_date"
            v-model="item.dateVente"
            :live="liveSasVente(26603, item)"
            :minValue="serverDate()"
          />
          <TextFieldLive
            :opqIf="item.jeSouhaiteVendreCettePharmacie"
            code="vente_acheteur"
            v-model="item.societeAcheteuse"
            :live="liveSasVente(26604, item)"
          />
        </template>
      </data-iterator>
    </div>
    <validate :that="!conditionVente || (conditionVente && getListVente.some((x) => x.jeSouhaiteVendreCettePharmacie))" else="condition_vente" />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  components: { OrganisationCardContent },
  props: {
    sas: { type: Object }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionVente() {
      return this.estOui(this.sas.sasSociete.declarerVentePharmacie)
    },
    getListVente() {
      return this.sas.ventesPharmacie.filter(
        (vente) =>
          !this.sas.demenagements.some(
            (demenagement) =>
              demenagement.pharmacieDemenagee &&
              demenagement.pharmacieDemenagee.organisationId === vente.ventePharmacie.organisationId &&
              demenagement.dateDemenagement !== null
          ) &&
          !this.sas.fermetures.some(
            (fermeture) =>
              fermeture.pharmacieFermee &&
              fermeture.pharmacieFermee.organisationId === vente.ventePharmacie.organisationId &&
              fermeture.dateDeFermeture !== null
          )
      )
    }
  },
  methods: {
    liveSasVente(cle, item) {
      return { endpoint: "sas-vente-pharmacie", cle: cle, fileId: item.id }
    },
    liveSasSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    cocherVendue(vente) {
      if (vente.jeSouhaiteVendreCettePharmacie) {
        vente.isExpanded = true
      }
    }
  }
}
</script>

<style></style>